import client from "@/api";
import store from "@/store";
import { _rotaGetSellers, _rotaGetSellersIds, _rotaGetCSVSellers } from "@/api/_caminhosApi";
import { arrayToFilterString } from "@/utils/array";

export function getCSV(from, to) {
  store.commit("interacoes/SET_LOADING", true);
  client
    .get(_rotaGetCSVSellers(), {
      params: {
        from,
        to,
      },
      responseType: "blob",
    })
    .then(resp => {
      if (resp.status === 200) {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "sellers.csv");
        document.body.appendChild(link);
        link.click();
      }
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}

export function getSellers(from, to, qtd, page, filters) {
  store.commit("interacoes/SET_LOADING", true);
  store.commit("sellers/RESET_SELLERS", null);
  client
    .get(`${_rotaGetSellers()}`, {
      params: {
        from,
        to,
        per_page: qtd,
        page: page,
        filters: arrayToFilterString(filters),
      },
    })
    .then(resp => {
      if (resp.status === 200) {
        store.commit("sellers/SET_SELLERS", resp.data);
      }
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}

export function getSellersList() {
  store.commit("interacoes/SET_LOADING", true);
  store.commit("sellers/RESET_SELLERS_LIST", null);
  client
    .get(`${_rotaGetSellersIds()}`)
    .then(resp => {
      if (resp.status === 200) {
        store.commit("sellers/SET_SELLERS_LIST", resp.data);
      }
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}